/* eslint-disable react/destructuring-assignment */
import { IconNotes, IconPackage } from '@tabler/icons-react';
import { Paper, SimpleGrid, Space, Textarea, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { PackagingType } from '../../../../../models/core/packaging.type';
import { Feature } from '../../../../../utils/constants.utils';
import PageSection from '../../../../../components/core/PageSection/PageSection';

type FormViewData = {
  idResiduoAcondicionamento: number | null;
  residuoAcondicionamento: string;
  descricao: string | null;
};

type FormViewProps = {
  save(data: FormViewData): void;
  packaging: PackagingType | null;
  loading: boolean;
};

function FormView(props: FormViewProps) {
  const form = useForm<FormViewData>({
    initialValues: {
      idResiduoAcondicionamento: props.packaging?.idResiduoAcondicionamento || null,
      residuoAcondicionamento: props.packaging?.residuoAcondicionamento || '',
      descricao: props.packaging?.descricao || '',
    },
    validate: {
      residuoAcondicionamento: (value) => (value.trim() !== '' ? null : 'Campo obrigatório'),
    },
  });

  const handleSubmit = async (formData: FormViewData) => {
    props.save({
      ...formData,
      residuoAcondicionamento: formData.residuoAcondicionamento.trim(),
      descricao: formData.descricao?.trim() || null,
    });
  };

  return (
    <form id="packaging-add-edit" onSubmit={form.onSubmit(handleSubmit)} noValidate>
      <Paper shadow="xs" p="md" withBorder>
        <PageSection size="lg" color={Feature.Reference.Packaging.color} label="Geral" text="" />
        <Space h="xs" />
        <SimpleGrid cols={5}>
          <TextInput
            leftSection={<IconPackage size={15} />}
            label="Acondicionamento"
            placeholder="Nome do acondicionamento"
            maxLength={50}
            required
            {...form.getInputProps('residuoAcondicionamento')}
          />
        </SimpleGrid>
        <Space h="xs" />
        <Textarea
          leftSection={<IconNotes size={15} />}
          label="Descrição"
          placeholder="Descrição do acondicionamento"
          autosize
          maxLength={500}
          {...form.getInputProps('descricao')}
        />
      </Paper>
    </form>
  );
}

export { FormView };
export type { FormViewData };
